class CardProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

    console.log('SCCS: Connected callback called');

    const addToCart = (id, callback) => {
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: id,
          quantity: 1
        })
      })
        .then((response) => response.json())
        .then(() => {
          const cartLinkCustom = document.querySelector('#cart-icon-bubble');
          if (cartLinkCustom) cartLinkCustom.click();

          callback();

          fetch(`${routes.cart_url}?section_id=cart-drawer`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
              for (const selector of selectors) {
                const targetElement = document.querySelector(selector);
                const sourceElement = html.querySelector(selector);
                if (targetElement && sourceElement) {
                  targetElement.replaceWith(sourceElement);
                }
              }
            
            const cartItemsCustomPlus = document.querySelectorAll('.quantity__button[name="plus"]')[0];
            const cartItemsCustomMinus = document.querySelectorAll('.quantity__button[name="minus"]')[0];
            if (cartItemsCustomPlus) {
              cartItemsCustomPlus.click();
              cartItemsCustomMinus.click();
            } 
          })
            .catch((e) => {
              console.error(e);
            });
        })
        .catch(error => console.error('Error adding to cart:', error));
    };

    const customizedProductCards = () => {
      
      window.webyzeInlineColorsQueue = window.webyzeInlineColorsQueue || []
      
      window.allProducts = window.allProducts || []

      const hasColorOptions = this.getAttribute('product-has-color-options') ? true : false;
      const colorsRef = this.querySelector('.webyze-colors');
      window.allProducts.push({
        productId: Number(this.getAttribute('product-id')), // {{ card_product.id }},
        url: this.getAttribute('product-url'), // "{{ card_product.url }}",
        shopDomain: "belyn-key.myshopify.com"
      });

      if (hasColorOptions) {
        window.webyzeInlineColorsQueue.push({
          productId: Number(this.getAttribute('product-id')), // {{ card_product.id }},
          url: this.getAttribute('product-url'), // "{{ card_product.url }}",
          shopDomain: "belyn-key.myshopify.com",
          selector: colorsRef.getAttribute('id')
        });
      }
      
      var customQuickButtons = this.getElementsByClassName('quick-add-to-cart-custom-button');
      for (var i = 0; i < customQuickButtons.length; i++) {
        var elCustom = customQuickButtons[i];
        if (elCustom) {
          elCustom.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
    
            const modal = this.nextElementSibling;
            const sizeButtons = modal.querySelectorAll('.size-option');
            var qab = this;

            if (sizeButtons.length == 1) {
              const selectedSizeId = sizeButtons[0].getAttribute('size-id');
              let id = Number(selectedSizeId);
              qab.disabled = true;
              addToCart(id, () => {
                qab.disabled = false;
              });
            } else {
              qab.style.display = 'none';
              modal.classList.remove('hidden');
              sizeButtons.forEach((button) => {
                button.addEventListener('click', function (event) {
                  event.preventDefault();
                  event.stopPropagation();
                  event.stopImmediatePropagation();
                  const selectedSize = this.innerText;
                  const selectedSizeId = this.getAttribute('size-id');
      
                  // let id = this.// {{ card_product.selected_or_first_available_variant.id }};
                  // if (selectedSizeId) {
                  let id = Number(selectedSizeId);
                  // }
                  addToCart(id, () => {
                    qab.style.display = 'block';
                    modal.classList.add('hidden');
                  });
                  
                });
              });
            }
          });
        }
      }

      if (hasColorOptions) {
        (async () => {
          let count = 0;
          while (!colorsRef.hasAttribute('data-loaded') && count < 100) {
            count++;
            await new Promise(resolve => setTimeout(resolve, 0.1 * 1000));
          }
          var customSwatchProductColors = this.querySelector('.webyze-colors').getElementsByClassName('swatchProductColor');
          for(var i = 0; i < customSwatchProductColors.length; i++) {
            var elCustomChild = customSwatchProductColors[i].firstChild;
            if (elCustomChild) {
              elCustomChild.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                const swatch = event.target.closest('.swatchProductColor');
                const handle = swatch.getAttribute('data-handle');
                const image = swatch.getAttribute('data-image');
                const cardWrapper = this.querySelector('.card-wrapper');
                if (image && cardWrapper) {
                  const img = cardWrapper.querySelector('.card__media img');
                  if (img) img.src = image;
                  cardWrapper.setAttribute('data-handle', handle);
                  const links = cardWrapper.querySelectorAll('a.full-unstyled-link');
                  links.forEach(link => {
                    link.href = '/products/' + handle;
                  });
                }
                // Mark current swatch
                const allSwatches = this.querySelectorAll('.swatchProductColor');
                allSwatches.forEach(s => s.classList.remove('currentSwatch'));
                swatch.classList.add('currentSwatch');

                // Disable quick-add while loading new product variants
                const quickAddBtn = this.querySelector('.quick-add-to-cart-custom-button');
                if (quickAddBtn) quickAddBtn.disabled = true;

                // Restore quick-add button and hide size modal
                const modal = this.querySelector('.size-modal');
                if (quickAddBtn) quickAddBtn.style.display = 'block';
                if (modal) modal.classList.add('hidden');

                // Update form variant ID and size buttons for the new product
                fetch('/products/' + handle + '.js')
                  .then(res => res.json())
                  .then(product => {
                    const form = this.querySelector('.shopify-product-form') || this.querySelector('form');
                    if (!form) return;
                    const hiddenId = form.querySelector('input[name="id"]');
                    const hiddenProductId = form.querySelector('input[name="product-id"]');
                    const sizesContainer = form.querySelector('.sizes-options');
                    if (!sizesContainer) return;

                    const firstAvailable = product.variants.find(v => v.available) || product.variants[0];
                    if (hiddenId) hiddenId.value = firstAvailable.id;
                    if (hiddenProductId) hiddenProductId.value = product.id;
                    form.id = 'product_form_' + product.id;

                    // Rebuild size buttons
                    sizesContainer.innerHTML = '';
                    product.variants.forEach(v => {
                      const btn = document.createElement('button');
                      btn.className = 'size-option' + (v.available ? '' : ' unavailable');
                      if (!v.available) btn.disabled = true;
                      if (v.available) btn.setAttribute('size-id', v.id);
                      btn.textContent = v.option2 || v.option1 || v.title;
                      sizesContainer.appendChild(btn);
                    });

                    // Update the displayed price to match the selected color
                    const priceEl = this.querySelector('.price');
                    if (priceEl) {
                      const formatMoney = (cents) =>
                        '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                      const onSale = product.compare_at_price && product.compare_at_price > product.price;

                      const regular = priceEl.querySelector('.price__regular .price-item--regular');
                      if (regular) regular.textContent = formatMoney(product.price);

                      const compareAt = priceEl.querySelector('.price__sale .price-item--regular');
                      if (compareAt) compareAt.textContent = formatMoney(product.compare_at_price || product.price);

                      const sale = priceEl.querySelector('.price__sale .price-item--sale');
                      if (sale) sale.textContent = formatMoney(product.price);

                      priceEl.classList.toggle('price--on-sale', !!onSale);
                    }
                  })
                  .catch(err => console.error('Error fetching product:', err))
                  .finally(() => {
                    if (quickAddBtn) quickAddBtn.disabled = false;
                  });
              });
            }
          }
        })();
      }
      
    }
    
    customizedProductCards();
  
    // setInterval(() => {
    //   customizedProductCards();
    //   window.webyzeProductColorsQueue = window.webyzeProductColorsQueue || [];
    //   window.webyzeProductColorsQueue.push({
    //     productId: {{ card_product.id }},
    //     shopDomain: "belyn-key.myshopify.com"
    //   });
    // }, 1000);

  }

  disconnectedCallback() {
    
  }
}

customElements.define('card-product', CardProduct)
